import pluralize from "pluralize";
import { ORGANISATION_MODEL } from "@/models/organisation-model";
import { PUBLISHING_SCHEDULE_TEMPLATE_MODEL } from "@/models/publishing-schedule-template-model";
import { PUBLISHING_CHANNEL_MODEL } from "@/models/publishing-channel-model";

export const SCHEDULE_TIER_MODEL = "publishing-schedule-tier";
export const PUBLISHING_SCHEDULE_TIERS = pluralize(SCHEDULE_TIER_MODEL);

const tierModel = {
  publishing_delay_hours: 0,
  tier_name: "",
  tier_nbr: "",
  publishing_schedule_id: 0,
  organisations: {
    jsonApi: "hasMany",
    type: ORGANISATION_MODEL
  },
  publishingScheduleTemplates: {
    jsonApi: "hasMany",
    type: pluralize(PUBLISHING_SCHEDULE_TEMPLATE_MODEL)
  },
  publishingChannels: {
    jsonApi: "hasMany",
    type: pluralize(PUBLISHING_CHANNEL_MODEL)
  }
};

export default tierModel;
